import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    HGWIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={HGWIconImg} preview={false}/>
